module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Spy-d7a49d2ce99cc58a40ccfb29b1e465d8.svg";